"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("../icon"));

var _events = _interopRequireDefault(require("../../utils/helpers/events"));

var _link = require("./link.style");

var _tags = _interopRequireDefault(require("../../utils/helpers/tags"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Link = /*#__PURE__*/_react.default.forwardRef(({
  children,
  className,
  onKeyDown,
  href,
  onClick,
  onMouseDown,
  icon,
  iconAlign,
  isSkipLink,
  disabled,
  ariaLabel,
  rel,
  tooltipMessage,
  tooltipPosition,
  tabbable,
  target,
  ...props
}, ref) => {
  const tabIndex = tabbable && !disabled ? "0" : "-1";

  const handleOnKeyDown = ev => {
    if (onKeyDown) {
      onKeyDown(ev);
    } // return early if there is no onClick or there is a href prop
    // or the event is not an enter key


    if (href || !_events.default.isEnterKey(ev) && !_events.default.isSpaceKey(ev)) {
      return;
    }

    if (onClick) {
      onClick(ev);
    }
  };

  const renderLinkIcon = (currentAlignment = "left") => {
    const hasProperAlignment = icon && iconAlign === currentAlignment;
    return hasProperAlignment ? /*#__PURE__*/_react.default.createElement(_icon.default, {
      type: icon,
      bgTheme: "none",
      iconColor: "business-color",
      disabled: disabled,
      ariaLabel: ariaLabel,
      tooltipMessage: tooltipMessage,
      tooltipPosition: tooltipPosition
    }) : null;
  };

  const componentProps = {
    onKeyDown: handleOnKeyDown,
    onMouseDown,
    onClick,
    disabled,
    tabIndex,
    target,
    ref,
    href,
    rel
  };

  const createLinkBasedOnType = () => {
    let type = "a";

    if (onClick && !href) {
      type = "button";
    }

    return /*#__PURE__*/_react.default.createElement(type, { ...componentProps
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderLinkIcon(), /*#__PURE__*/_react.default.createElement(_link.StyledContent, !children && {
      "aria-label": ariaLabel,
      role: "link"
    }, isSkipLink ? "Skip to main content" : children), renderLinkIcon("right")));
  };

  return /*#__PURE__*/_react.default.createElement(_link.StyledLink, _extends({
    isSkipLink: isSkipLink,
    disabled: disabled,
    className: className,
    iconAlign: iconAlign,
    hasContent: Boolean(children)
  }, (0, _tags.default)("link", props), isSkipLink && {
    "data-element": "skip-link"
  }), createLinkBasedOnType());
});

Link.propTypes = {
  /** Child content to render in the link. */
  children: _propTypes.default.node,

  /** Classes to apply to the component. */
  className: _propTypes.default.string,

  /** The disabled state of the link. */
  disabled: _propTypes.default.bool,

  /** An href for an anchor tag. */
  href: _propTypes.default.string,

  /**
   * <a href="https://brand.sage.com/d/NdbrveWvNheA/foundations#/icons/icons" target="_blank">List of supported icons</a>
   *
   * An icon to display next to the link.
   */
  icon: _propTypes.default.string,

  /** Which side of the link to the render the link. */
  iconAlign: _propTypes.default.string,

  /** Function called when the mouse is clicked. */
  onClick: _propTypes.default.func,

  /** Function called when a key is pressed. */
  onKeyDown: _propTypes.default.func,

  /** Function called when a mouse down event triggers. */
  onMouseDown: _propTypes.default.func,

  /** Whether to include the link in the tab order of the page */
  tabbable: _propTypes.default.bool,

  /** A message to display as a tooltip to the link. */
  tooltipMessage: _propTypes.default.string,

  /** Positions the tooltip with the link. */
  tooltipPosition: _propTypes.default.oneOf(["bottom", "left", "right", "top"]),

  /** Allows to create skip link */
  isSkipLink: _propTypes.default.bool,

  /** Target property in which link should open ie: _blank, _self, _parent, _top */
  target: _propTypes.default.string,

  /** Aria label for accessibility purposes */
  ariaLabel: _propTypes.default.string,

  /** allows to set rel property in <a> tag */
  rel: _propTypes.default.string
};
Link.defaultProps = {
  iconAlign: "left",
  tabbable: true
};
var _default = Link;
exports.default = _default;